module.exports = __webpack_public_path__ + "img/2豪华双层套房.855dca1.jpg";